import React, { useEffect } from "react";
import { motion } from "framer-motion";
import AOS from "aos";
import "aos/dist/aos.css";
import "./tools.css";

import one from "../../assets/javaimages/tools/html.svg";
import two from "../../assets/javaimages/tools/boo.png";
import three from "../../assets/javaimages/tools/css.png";
import four from "../../assets/javaimages/tools/docker.png";
import five from "../../assets/javaimages/tools/hibernate.png";
import six from "../../assets/javaimages/tools/java.png";
import seven from "../../assets/javaimages/tools/javascript.png";
import eight from "../../assets/javaimages/tools/jenkins.png";
import nine from "../../assets/javaimages/tools/mysql.png";
import ten from "../../assets/javaimages/tools/react.png";
import elven from "../../assets/javaimages/tools/spring.png";
import twele from "../../assets/javaimages/tools/thymeleaf.png";

const clients = [
  { src: one, alt: "Apache JMeter" },
  { src: two, alt: "Appium" },
  { src: three, alt: "Appium JPG" },
  { src: four, alt: "Cucumber" },
  { src: five, alt: "Java" },
  { src: six, alt: "Jenkins" },
  { src: seven, alt: "JUnit" },
  { src: eight, alt: "LoadRunner" },
  { src: nine, alt: "Postman" },
  { src: ten, alt: "Selenium" },
  { src: elven, alt: "SoapUI" },
  { src: twele, alt: "TestNG" },
];

function Tools() {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  return (
    <>
      <section style={{ marginTop: "50px" }}>
        <div className="headlines-for-all">
          <h4     data-aos="fade-up" >
            <span>Tools </span> Covered
          </h4>
          <p     data-aos="fade-up">
          Gain hands-on experience with the most in-demand Java Full Stack technologies, frameworks, and development tools used by modern software developers.
          </p>
        </div>
      </section>

      <section className="our-clients-section">
        <div className="our-clients-container">
          <motion.div
            className="our-clients-track"
            animate={{ x: ["0%", "-100%"] }}
            transition={{
              ease: "linear",
              duration: 100,
              repeat: Infinity,
            }}
          >
            {[...clients, ...clients].map((client, i) => (
              <div
                className="client-item"
                key={i}
                data-aos="fade-up"
                data-aos-delay={i * 150} // DELAY ONE-BY-ONE
              >
                <img src={client.src} alt={client.alt} />
              </div>
            ))}
          </motion.div>
        </div>
      </section>
    </>
  );
}

export default Tools;
